<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" :items="items" class="mc-page-three" />
      <p class="mb-4">{{ $t('maintenance.detailSchedule.desc') }}</p>

      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="d-flex justify-content-end">
          <McButton
            variant="secondary"
            class="me-2"
            @click="
              track('Open Change Log Maintenance')
              $router.push({
                name: 'Log Maintenance Detail Service Shceduler',
                params: { vehicleId: $route.params.vehicleId },
              })
            "
            icon="icon-outline_file-text"
            :text="$t('global.historyUpdate')"
          />

          <McButton
            variant="secondary"
            @click="$router.push({ name: 'List Service Schedule' })"
            icon="icon-outline_arrow-left"
            :text="$t('global.back')"
          />
        </div>
      </div>
    </div>
    <div class="clearfix mb-4">
      <h4 class="card-title float-start">{{ $t('master.form.fleet.fleetInformation') }}</h4>
    </div>
    <b-skeleton-wrapper :loading="isLoading">
      <template #loading>
        <b-card>
          <b-row>
            <b-col>
              <b-skeleton width="70%" height="50px"></b-skeleton>
            </b-col>
            <b-col>
              <b-skeleton width="70%" height="50px"></b-skeleton>
            </b-col>
            <b-col>
              <b-skeleton width="70%" height="50px"></b-skeleton>
            </b-col>
            <b-col>
              <b-skeleton width="70%" height="50px"></b-skeleton>
            </b-col>
            <b-col>
              <b-skeleton width="70%" height="50px"></b-skeleton>
            </b-col>
            <b-col>
              <b-skeleton width="70%" height="50px"></b-skeleton>
            </b-col>
          </b-row>
        </b-card>
        <b-row class="mb-5">
          <b-col>
            <b-card>
              <b-skeleton width="70%" height="50px"></b-skeleton>
            </b-card>
          </b-col>
          <b-col>
            <b-card>
              <b-skeleton width="70%" height="50px"></b-skeleton>
            </b-card>
          </b-col>
          <b-col>
            <b-card>
              <b-skeleton width="70%" height="50px"></b-skeleton>
            </b-card>
          </b-col>
          <b-col>
            <b-card>
              <b-skeleton width="70%" height="50px"></b-skeleton>
            </b-card>
          </b-col>
        </b-row>

        <b-card class="mt-5">
          <b-skeleton width="100%" height="400px"></b-skeleton>
        </b-card>
      </template>
      <b-card>
        <b-row class="mc-list-info__top">
          <b-col>
            <span>{{ $t('global.object.licensePlate') }}</span>
            <strong>{{ vehicle?.licensePlate }}</strong>
          </b-col>

          <b-col>
            <span>{{ $t('global.field.vehicleType') }}</span>
            <strong>{{ vehicle?.vehicleType?.type }}</strong>
          </b-col>

          <b-col>
            <span>{{ $t('global.object.fleetCategory') }}</span>
            <strong>{{ vehicle?.vehicleType?.category }}</strong>
          </b-col>

          <b-col>
            <span>{{ $t('setting.list.fleetSetting.fleetModel') }}</span>
            <strong>{{
              `${vehicle?.vehicleType?.manufacturer} - ${vehicle?.vehicleType?.model}`
            }}</strong>
          </b-col>

          <b-col lg="2" md="6" class="border-start">
            <span>{{ $t('maintenance.field.odoFleetNow') }}</span>
            <strong>{{ `${thousandFormat(vehicle?.odometer)} Km ` }} </strong>
            <i class="mc-fa ms-2 icon-fill_sync" id="odoNow" @click="refreshVehicle"></i>
            <b-tooltip target="odoNow" triggers="hover" placement="rightbottom">
              <p>{{ $t('maintenance.tooltip.odoNow') }} :</p>
              <span>{{
                vehicleStatus.lastPacket ? momentDMYHS(vehicleStatus.lastPacket) : '-'
              }}</span>
            </b-tooltip>
          </b-col>

          <b-col lg="2" md="5">
            <span>{{ $t('maintenance.form.hourmeterFleetNow') }}</span>
            <strong>{{ minuteToHour(vehicle?.hourmeter) }} </strong>
            <i class="mc-fa ms-2 icon-fill_sync" id="hourmeterFleetNow" @click="refreshVehicle"></i>
            <b-tooltip target="hourmeterFleetNow" triggers="hover" placement="rightbottom">
              <p>{{ $t('maintenance.tooltip.odoNow') }} :</p>
              <span>{{
                vehicleStatus.lastPacket ? momentDMYHS(vehicleStatus.lastPacket) : '-'
              }}</span>
            </b-tooltip>
          </b-col>
          
          <b-col v-if="isMGMAndMO" lg="2" md="5">
            <span>{{ $t('maintenance.form.refrigeratorFleetNow') }}</span>
            <strong>{{ minuteToHour(vehicle?.refrigerator) }} </strong>
            <i class="mc-fa ms-2 icon-fill_sync" id="refrigeratorFleetNow" @click="refreshVehicle"></i>
            <b-tooltip target="refrigeratorFleetNow" triggers="hover" placement="rightbottom">
              <p>{{ $t('maintenance.tooltip.odoNow') }} :</p>
              <span>{{
                vehicleStatus.lastPacket ? momentDMYHS(vehicleStatus.lastPacket) : '-'
              }}</span>
            </b-tooltip>
          </b-col>
        </b-row>
      </b-card>

      <b-row class="mc-dashboard-card no-hover">
        <b-col class="mc-dashboard-card__item" md="3">
          <div class="card mini-stats-wid">
            <div class="card-body">
              <div class="row">
                <div class="col-md-9">
                  <p class="text-muted">{{ $t('maintenance.status.lateService') }}</p>
                  <h5 class="font-size-13 mb-0">
                    {{ selectedDataHeader.totalLate }}
                  </h5>
                </div>
                <div class="avatar-sm">
                  <div class="avatar-title rounded-circle bg-danger font-size-20">
                    <i class="icon-outline_alert-triangle mc-fa"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-col>
        <b-col class="mc-dashboard-card__item" md="3">
          <div class="card mini-stats-wid">
            <div class="card-body">
              <div class="row">
                <div class="col-md-9">
                  <p class="text-muted">{{ $t('maintenance.status.approachingService') }}</p>
                  <h5 class="font-size-13 mb-0">
                    {{ selectedDataHeader.totalSoon }}
                  </h5>
                </div>
                <div class="avatar-sm">
                  <div class="avatar-title rounded-circle bg-warning font-size-20">
                    <i class="icon-outline_timer mc-fa"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-col>
        <b-col class="mc-dashboard-card__item" md="3">
          <div class="card mini-stats-wid">
            <div class="card-body">
              <div class="row">
                <div class="col-md-9">
                  <p class="text-muted">{{ $t('maintenance.status.inService') }}</p>
                  <h5 class="font-size-13 mb-0">
                    {{ selectedDataHeader.totalInProgress }}
                  </h5>
                </div>
                <div class="avatar-sm">
                  <div class="avatar-title rounded-circle bg-info font-size-20">
                    <i class="icon-outline_truck-maintenance mc-fa"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-col>
        <b-col class="mc-dashboard-card__item" md="3">
          <div class="card mini-stats-wid">
            <div class="card-body">
              <div class="row">
                <div class="col-md-9">
                  <p class="text-muted">{{ $t('maintenance.status.normal') }}</p>
                  <h5 class="font-size-13 mb-0">
                    {{ selectedDataHeader.totalNormal }}
                  </h5>
                </div>
                <div class="avatar-sm">
                  <div class="avatar-title rounded-circle bg-success font-size-20">
                    <i class="icon-fill_checkmark mc-fa"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-skeleton-wrapper>

    <div v-if="!isLoading">
      <div>
        <!-- Kilometer & Waktu -->
        <div class="table-responsive my-3">
          <McGrapqlTable
            v-show="tabSelected == '1'"
            :apiClient="query"
            :fields="kmFields"
            :customHandlers="customHandlers"
            :hasCheckbox="true"
            :hasDelete="false"
            :searchable="true"
            :withCard="true"
            trackBy="serviceId"
            :hasDisabled="false"
            :stickyHeader="true"
            :stickyCheckbox="true"
            :customButton="true"
            :refreshData="isLoading"
            :customToast="customToast"
            @totalSelected="handleSelected"
            @handleSelectValue="handleSelectedValue"
          >
            <template #button-header>
              <McButton
                @click="openModal"
                variant="secondary"
                :text="$t('maintenance.unlinkGroup')"
                icon="mc-fa icon-outline_link-2"
                class="mx-2 mb-2 ms-auto"
                v-if="
                  hasAccess([
                    'maintenance-group:read',
                    'maintenance-group:update',
                    'maintenance-group:create',
                    'maintenance-group:delete',
                  ]) && !isDisabled
                "
              />

              <DropdownShortcut :disabled="!selectedDataLength" />

              <McButton
                :text="$t('maintenance.frontPage.title.addScheduler')"
                :class="`mb-2 ms-auto ${selectedDataLength ? ' me-2' : ''}`"
                icon="icon-fill_plus"
                @click="
                  $router.push({
                    name: 'Create Service Schedule',
                    params: {
                      vehicleId: $route.params.vehicleId,
                    },
                  })
                "
              />
            </template>
            <template #tab-button="{ handleUnselectAll }">
              <div class="mc-btn--tab">
                <b-form-radio-group
                  id="btn-radio"
                  v-model="tabSelected"
                  :options="tabOptions"
                  button-variant="outline-primary"
                  size="md"
                  class="radio-tab mb-2"
                  name="radio-btn-outline"
                  @change="handleUnselectAll"
                  buttons
                  v-if="showTabFilter"
                ></b-form-radio-group>
              </div>
            </template>
            <template #viewManager="{ handleSetDataFields, dataFields, initialFields }">
              <McFilterSelect
                :defaultColumnOrder="initialFields"
                :currentColumnOrder="dataFields"
                @setColumn="handleSetDataFields"
                @setField="handleFieldDistance"
              />
            </template>
            <template #cell(service.name)="data">
              <div
                class="fw-bold text-primary td__noellipsis clickable-field"
                @click="customHandlers.handleClickRow(data.item, 'DistanceAndTime')"
                v-b-tooltip.hover.right="data.value.length > 30 ? data.value : null"
              >
                {{ data.value.length > 30 ? data.value.slice(0, 30) + '...' : data.value }}
              </div>
            </template>

            <template #cell(status)="data">
              <span :class="`mc-status mc-status--${data.value.color}`">
                {{ data.value.label }}
              </span>
            </template>

            <template #cell(ssgroup.name)="data">
              {{ data.value ? data.value : '-' }}
            </template>
            <template #cell(serviceOrder)="data">
              <span
                class="fw-bold text-primary td__noellipsis clickable-field"
                @click="
                  $router.push({
                    name: 'Maintenance Detail Service Order',
                    params: {
                      id: data.value.serviceOrderId,
                    },
                  })
                "
              >
                {{ data.value ? data.value.code : '-' }}
              </span>
            </template>

            <template #cell(vehicle.odometer)="data">
              {{ thousandFormat(data.value) }}
            </template>

            <template #cell(startServiceAtDistance)="data">
              <span v-if="data.item.status.includes('LO')" class="text-danger">
                {{ data.value }}
              </span>
              <span v-else-if="data.item.status.includes('SO')" class="text-warning">
                {{ data.value }}
              </span>
              <span v-else class="text-dark">
                {{ data.value }}
              </span>
            </template>

            <template #cell(startServiceAtTime)="data">
              <span v-if="data.item.status.includes('LD')" class="text-danger">
                {{ data.value }}
              </span>
              <span v-else-if="data.item.status.includes('SD')" class="text-warning">
                {{ data.value }}
              </span>
              <span v-else class="text-dark">
                {{ data.value }}
              </span>
            </template>

            <template #cell(serviceDistanceDifference)="data">
              {{ thousandFormat(data.value) }}
            </template>

            <template #cell(serviceTimeDifference.readableText)="data">
              {{ data.item.serviceTimeDifference.isDatePassed ? '-' : '' }}
              {{
                data.item.serviceTimeDifference.years == 0
                  ? ''
                  : `${data.item.serviceTimeDifference.years} ${$t('global.time.year')}`
              }}
              {{
                data.item.serviceTimeDifference.months == 0
                  ? ''
                  : `${data.item.serviceTimeDifference.months} ${$t('global.time.month')}`
              }}
              {{
                data.item.serviceTimeDifference.days == 0
                  ? ''
                  : `${data.item.serviceTimeDifference.days} ${$t('global.time.days')}`
              }}
            </template>
          </McGrapqlTable>

          <!-- Durasi Jam Kerja -->
          <McGrapqlTable
            v-show="tabSelected == '2'"
            :apiClient="queryHourmeter"
            :fields="hourmeterFields"
            :customHandlers="customHandlers"
            :hasCheckbox="true"
            :hasDelete="false"
            :searchable="true"
            :withCard="true"
            trackBy="serviceId"
            :hasDisabled="false"
            :stickyHeader="true"
            :stickyCheckbox="true"
            :customButton="true"
            :refreshData="isLoading"
            :customToast="customToast"
            @totalSelected="handleSelected"
            @handleSelectValue="handleSelectedValue"
          >
            <template #button-header>
              <McButton
                @click="openModal"
                variant="secondary"
                :text="$t('maintenance.unlinkGroup')"
                icon="mc-fa icon-outline_link-2"
                class="mx-2 mb-2 ms-auto"
                v-if="
                  hasAccess([
                    'maintenance-group:read',
                    'maintenance-group:update',
                    'maintenance-group:create',
                    'maintenance-group:delete',
                  ]) && !isDisabled
                "
              />

              <DropdownShortcut :disabled="!selectedDataLength" :selectedIds="selectedIds" />

              <McButton
                :text="$t('maintenance.frontPage.title.addScheduler')"
                :class="`mb-2 ms-auto ${selectedDataLength ? ' me-2' : ''}`"
                icon="icon-fill_plus"
                @click="
                  $router.push({
                    name: 'Create Service Schedule',
                    params: {
                      vehicleId: $route.params.vehicleId,
                    },
                  })
                "
              />
            </template>
            <template #tab-button="{ handleUnselectAll }">
              <div class="mc-btn--tab">
                <b-form-radio-group
                  id="btn-radio"
                  v-model="tabSelected"
                  :options="tabOptions"
                  button-variant="outline-primary"
                  size="md"
                  class="radio-tab mb-2"
                  name="radio-btn-outline"
                  buttons
                  @change="handleUnselectAll"
                  v-if="showTabFilter"
                ></b-form-radio-group>
              </div>
            </template>
            <template #viewManager="{ handleSetDataFields, dataFields, initialFields }">
              <McFilterSelect
                :defaultColumnOrder="initialFields"
                :currentColumnOrder="dataFields"
                @setColumn="handleSetDataFields"
                @setField="handleFieldHourmeter"
              />
            </template>
            <template #cell(service.name)="data">
              <div
                class="fw-bold text-primary td__noellipsis clickable-field"
                @click="customHandlers.handleClickRow(data.item, 'Hourmeter')"
                v-b-tooltip.hover.right="data.value.length > 30 ? data.value : null"
              >
                {{ data.value.length > 30 ? data.value.slice(0, 30) + '...' : data.value }}
              </div>
            </template>

            <template #cell(status)="data">
              <span :class="`mc-status mc-status--${data.value.color}`">
                {{ data.value.label }}
              </span>
            </template>

            <template #cell(ssgroup.name)="data">
              {{ data.value ? data.value : '-' }}
            </template>
            <template #cell(serviceOrder)="data">
              <span
                class="fw-bold text-primary td__noellipsis clickable-field"
                @click="
                  $router.push({
                    name: 'Maintenance Detail Service Order',
                    params: {
                      id: data.value.serviceOrderId,
                    },
                  })
                "
              >
                {{ data.value ? data.value.code : '-' }}
              </span>
            </template>

            <template #cell(startServiceAtHourmeter)="data">
              <span v-if="data.item.status.includes('LH')" class="text-danger">
                {{ data.value }}
              </span>
              <span v-else-if="data.item.status.includes('SH')" class="text-warning">
                {{ data.value }}
              </span>
              <span v-else class="text-dark">
                {{ data.value }}
              </span>
            </template>
          </McGrapqlTable>

          <!-- Durasi Refrigerator -->
          <McGrapqlTable
            v-show="tabSelected == '3'"
            :apiClient="queryRefrigerator"
            :fields="refrigeratorFields"
            :customHandlers="customHandlers"
            :hasCheckbox="true"
            :hasDelete="false"
            :searchable="true"
            :withCard="true"
            trackBy="serviceId"
            :hasDisabled="false"
            :stickyHeader="true"
            :stickyCheckbox="true"
            :customButton="true"
            :refreshData="isLoading"
            :customToast="customToast"
            @totalSelected="handleSelected"
            @handleSelectValue="handleSelectedValue"
          >
            <template #button-header>
              <McButton
                @click="openModal"
                variant="secondary"
                :text="$t('maintenance.unlinkGroup')"
                icon="mc-fa icon-outline_link-2"
                class="mx-2 mb-2 ms-auto"
                v-if="
                  hasAccess([
                    'maintenance-group:read',
                    'maintenance-group:update',
                    'maintenance-group:create',
                    'maintenance-group:delete',
                  ]) && !isDisabled
                "
              />

              <DropdownShortcut :disabled="!selectedDataLength" :selectedIds="selectedIds" />

              <McButton
                :text="$t('maintenance.frontPage.title.addScheduler')"
                :class="`mb-2 ms-auto ${selectedDataLength ? ' me-2' : ''}`"
                icon="icon-fill_plus"
                @click="
                  $router.push({
                    name: 'Create Service Schedule',
                    params: {
                      vehicleId: $route.params.vehicleId,
                    },
                  })
                "
              />
            </template>
            <template #tab-button="{ handleUnselectAll }">
              <div class="mc-btn--tab">
                <b-form-radio-group
                  v-if="showTabFilter"
                  id="btn-radio"
                  v-model="tabSelected"
                  :options="tabOptions"
                  button-variant="outline-primary"
                  size="md"
                  class="radio-tab mb-2"
                  name="radio-btn-outline"
                  buttons
                  @change="handleUnselectAll"
                />
              </div>
            </template>
            <template #viewManager="{ handleSetDataFields, dataFields, initialFields }">
              <McFilterSelect
                :defaultColumnOrder="initialFields"
                :currentColumnOrder="dataFields"
                @setColumn="handleSetDataFields"
                @setField="handleFieldRefrigerator"
              />
            </template>
            <template #cell(service.name)="data">
              <div
                class="fw-bold text-primary td__noellipsis clickable-field"
                @click="customHandlers.handleClickRow(data.item, 'Refrigerator')"
                v-b-tooltip.hover.right="data.value.length > 30 ? data.value : null"
              >
                {{ data.value.length > 30 ? data.value.slice(0, 30) + '...' : data.value }}
              </div>
            </template>

            <template #cell(status)="data">
              <span :class="`mc-status mc-status--${data.value.color}`">
                {{ data.value.label }}
              </span>
            </template>

            <template #cell(ssgroup.name)="data">
              {{ data.value ? data.value : '-' }}
            </template>
            <template #cell(serviceOrder)="data">
              <span
                class="fw-bold text-primary td__noellipsis clickable-field"
                @click="
                  $router.push({
                    name: 'Maintenance Detail Service Order',
                    params: {
                      id: data.value.serviceOrderId,
                    },
                  })
                "
              >
                {{ data.value ? data.value.code : '-' }}
              </span>
            </template>

            <template #cell(startServiceAtRefrigerator)="data">
              <span v-if="data.item.status.includes('LH')" class="text-danger">
                {{ data.value }}
              </span>
              <span v-else-if="data.item.status.includes('SH')" class="text-warning">
                {{ data.value }}
              </span>
              <span v-else class="text-dark">
                {{ data.value }}
              </span>
            </template>
          </McGrapqlTable>
        </div>
      </div>
    </div>
    <ModalUnlinkGroup v-if="modal" :serviceSchedules="dataServices" @refreshData="refreshData" />

    <ModalChangeStatus
      v-if="selectedDataLength"
      :selectedDataLength="selectedDataLength"
      :selectedIds="selectedIds"
      :selectedItems="selectedItems"
      @refreshPage="refreshData"
    />
    <ModalFinishStatus
      v-if="selectedDataLength"
      :selectedDataLength="selectedDataLength"
      :selectedIds="selectedIds"
      :selectedItems="selectedItems"
      @refreshPage="refreshData"
    />
    <ModalCreateMo
      v-if="selectedDataLength"
      :selectedDataLength="selectedDataLength"
      :selectedItems="selectedItems"
      :selectedIds="selectedIds"
    />
    <ModalDelete
      v-if="selectedDataLength"
      :selectedDataLength="selectedDataLength"
      :selectedItems="selectedItems"
      :selectedIds="selectedIds"
      @refreshPage="refreshData"
    />
  </Layout>
</template>
<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import McGrapqlTable from '@/components/McGrapqlTable'
import McFilterSelect from '@/components/McFilterSelect'
import { Helper } from '@/mixin/helper'
import {
  GET_SERVICE_SCHEDULES,
  DELETE_SERVICE_SCHEDULE,
} from '@/services/api/maintenance/serviceSchedules'
import { GET_VEHICLE_STATUS_BY_ID } from '@/services/api/fleet'
import { GET_VEHICLE_ID } from '@/services/api/master/fleet'
import ModalUnlinkGroup from './ModalUnlinkGroup'
import McButton from '@/components/McButton'
import { mapGetters } from 'vuex'
import cloneDeep from 'lodash/cloneDeep'
import DropdownShortcut from './shortcut/Dropdown.vue'
import ModalChangeStatus from './shortcut/ModalChangeStatus.vue'
import ModalFinishStatus from './shortcut/ModalFinishStatus.vue'
import ModalCreateMo from './shortcut/ModalCreateMo.vue'
import ModalDelete from './shortcut/ModalDelete.vue'
import { MixPanel } from '@/mixin/mixpanel'

/**
 * Starter component
 */
export default {
  page: {
    title: 'Servis',
    meta: [{ name: 'description', content: appConfig.description }],
  },

  components: {
    Layout,
    PageHeader,
    McGrapqlTable,
    ModalUnlinkGroup,
    McButton,
    McFilterSelect,
    DropdownShortcut,
    ModalChangeStatus,
    ModalFinishStatus,
    ModalCreateMo,
    ModalDelete,
  },

  mixins: [Helper, MixPanel],

  apollo: {
    serviceSchedules: {
      query: GET_SERVICE_SCHEDULES,
      fetchPolicy: 'no-cache',
      variables() {
        return {
          filter: {
            vehicleId: Number(this.$route.params.vehicleId),
            vehicleStatus: ['I', 'R'],
            pagination: {
              page: 1,
              show: 99999,
            },
          },
        }
      },
      result({ data, loading }) {
        if (loading) return
        if (data) {
          this.dataServices = data.serviceSchedules.serviceSchedules.data.serviceSchedules
          this.$store.commit('maintenance/SET_SERVICES', this.dataServices)
          this.checkSsgroup(this.dataServices)
        }
      },
    },
    vehicleStatus: {
      query: GET_VEHICLE_STATUS_BY_ID,
      fetchPolicy: 'no-cache',
      variables() {
        return {
          filter: {
            vehicleId: Number(this.$route.params.vehicleId),
          },
        }
      },
      result({ data, loading }) {
        if (loading) return
        this.vehicleStatus = data.vehicleStatus.vehicleStatus
      },
    },
    vehicle: {
      query: GET_VEHICLE_ID,
      fetchPolicy: 'no-cache',
      variables() {
        return {
          filter: {
            id: Number(this.$route.params.vehicleId),
          },
        }
      },
      result({ data }) {
        this.vehicle = data.vehicle.vehicle
        this.isLoading = false
      },
    },
  },

  data() {
    return {
      total: {
        DistanceAndTime: 0,
        Hourmeter: 0,
        Refrigerator: 0,
      },
      tabSelected: '',
      dataheader: {
        distanceAndTime: {},
        hourmeter: {},
        refrigerator: {},
      },
      serviceSchedules: {
        serviceSchedules: {
          data: [
            {
              serviceSchedules: [],
            },
          ],
        },
      },
      customHandlers: {
        handleClickRow: (item, type) => {
          return this.$router.push({
            name: 'Form Service Schedule',
            params: {
              vehicleId: this.$route.params.vehicleId,
              serviceId: item.serviceId,
              ssgroupId: item.ssgroupId,
              serviceType: type,
            },
          })
        },
        handleDisabledRow: (data) => {
          if (data.ssgroupId) return true
          return false
        },
      },
      vehicle: {},
      vehicleStatus: {},
      refresh: false,
      filter: null,
      dataServices: [],
      render: true,
      modal: false,
      isDisabled: true,
      created: true,
      distanceFieldShow: JSON.parse(localStorage.getItem('ssDistanceFields')),
      hourmeterFieldShow: JSON.parse(localStorage.getItem('ssHourmeterFields')),
      refrigeratorFieldShow: JSON.parse(localStorage.getItem('ssRefrigeratorFields')),
      isLoading: true,
      selectedDataLength: 0,
      selectedIds: [],
    }
  },

  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      getFeatureFlagValue: 'identity/getFeatureFlagValue',
    }),
    isMGMAndMO() {
      const data = this.getFeatureFlagValue('customFeature.mgm')
      return (
        Array.isArray(data?.company_id) &&
        data.company_id.includes(this.getCompanyId()) &&
        data.features?.maintenance_order
      )
    },
    showTabFilter() {
      const showTabFilter =
        Object.keys(
          Object.fromEntries(Object.entries(this.total).filter(([_, value]) => value > 0))
        ).length > 1
      return showTabFilter
    },
    selectedDataHeader() {
      const headerKeyByTab = {
        1: 'distanceAndTime',
        2: 'hourmeter',
        3: 'refrigerator',
      }

      return this.dataheader[headerKeyByTab[this.tabSelected]] ?? {}
    },
    title() {
      return this.$t('maintenance.detailSchedule.title')
    },

    tabOptions() {
      return [
        this.total['DistanceAndTime'] && {
          text: `${this.$t('maintenance.form.kmTime')} (${this.total['DistanceAndTime']})`,
          value: '1',
          key: 'DistanceAndTime',
        },
        this.total['Hourmeter'] && {
          text: `${this.$t('maintenance.form.hourmeter')} (${this.total['Hourmeter']})`,
          value: '2',
          key: 'Hourmeter',
        },
        this.isMGMAndMO && this.total['Refrigerator'] && {
          text: `${this.$t('maintenance.form.refrigerator')} (${this.total['Refrigerator']})`,
          value: '3',
          key: 'Refrigerator',
        },
      ].filter(Boolean)
    },

    items() {
      return [
        {
          text: this.$t('maintenance.title'),
          to: { name: 'Service' },
        },
        {
          text: this.$t('maintenance.frontPage.title.serviceSchedule'),
          to: { name: 'List Service Schedule' },
        },
        {
          text: this.$t('maintenance.detailSchedule.title'),
        },
      ]
    },

    query() {
      return {
        get: async (filter) => {
          filter.type = 'DistanceAndTime'
          return this.get(filter)
        },

        delete: async (id) => {
          const res = await this.$apollo.mutate({
            mutation: DELETE_SERVICE_SCHEDULE,
            variables: {
              input: {
                serviceId: Number(id),
                vehicleId: Number(this.$route.params.vehicleId),
                type: 'DistanceAndTime',
              },
            },
          })
          if (res.data.deleteServiceSchedule.isSuccessful) {
            this.updateTotal('DistanceAndTime', this.total['DistanceAndTime'] - 1)
          }
          return res.data.deleteServiceSchedule.isSuccessful
        },
      }
    },
    queryHourmeter() {
      return {
        get: async (filter) => {
          filter.type = 'Hourmeter'
          return this.get(filter)
        },

        delete: async (id) => {
          const res = await this.$apollo.mutate({
            mutation: DELETE_SERVICE_SCHEDULE,
            variables: {
              input: {
                serviceId: Number(id),
                vehicleId: Number(this.$route.params.vehicleId),
                type: 'Hourmeter',
              },
            },
          })
          if (res.data.deleteServiceSchedule.isSuccessful) {
            this.updateTotal('Hourmeter', this.total['Hourmeter'] - 1)
          }
          return res.data.deleteServiceSchedule.isSuccessful
        },
      }
    },
    queryRefrigerator() {
      return {
        get: async (filter) => {
          filter.type = 'Refrigerator'
          return this.get(filter)
        },

        delete: async (id) => {
          const res = await this.$apollo.mutate({
            mutation: DELETE_SERVICE_SCHEDULE,
            variables: {
              input: {
                serviceId: Number(id),
                vehicleId: Number(this.$route.params.vehicleId),
                type: 'Refrigerator',
              },
            },
          })
          if (res.data.deleteServiceSchedule.isSuccessful) {
            this.updateTotal('Refrigerator', this.total['Refrigerator'] - 1)
          }
          return res.data.deleteServiceSchedule.isSuccessful
        },
      }
    },
    optionalFields() {
      let fields = []

      if (
        this.hasAccess([
          'maintenance-group:read',
          'maintenance-group:update',
          'maintenance-group:create',
          'maintenance-group:delete',
        ])
      ) {
        fields = [
          {
            key: 'ssgroup.name',
            label: 'maintenance.frontPage.title.serviceGroup',
            isSortable: true,
          },
        ]
      }

      if (this.serviceOrderSubs) {
        fields.push({
          key: 'serviceOrder',
          label: 'maintenance.serviceOrderNo',
          isSortable: true,
        })
      }

      return fields
    },
    kmStoredFields() {
      for (const field of this.distanceFieldShow.column) {
        if (field.key == 'service.name') {
          field.formatter = (val, key, item) => {
            return `${val} (${item.service.serviceAction.action})`
          }
        }
        if (field.key == 'status') {
          field.formatter = (val) => {
            let format = { color: 'green', label: this.$t('maintenance.status.normal') }
            if (val.includes('I')) {
              format = { color: 'blue', label: this.$t('maintenance.status.inService') }
            } else if (val.includes('LO') || val.includes('LD')) {
              format = { color: 'red', label: this.$t('maintenance.status.lateService') }
            } else if (val.includes('SO') || val.includes('SD')) {
              format = {
                color: 'yellow',
                label: this.$t('maintenance.status.approachingService'),
              }
            }
            return format
          }
        }
        if (field.key == 'intervalDistance' || field.key == 'startServiceAtDistance') {
          field.formatter = (val) => {
            return `${this.thousandFormat(val)} km`
          }
        }
        if (field.key == 'intervalTime') {
          field.formatter = (value, key, item) => {
            let period = this.$t('global.time.days')
            switch (item.intervalPeriod) {
              case 'w':
                period = this.$t('global.time.week')
                break
              case 'm':
                period = this.$t('global.time.month')
                break
              case 'y':
                period = this.$t('global.time.year')
                break

              default:
                break
            }
            return `${value} ${period}`
          }
        }
        if (field.key == 'startServiceAtTime') {
          field.formatter = (val) => {
            return this.momentDateShortMonth(val)
          }
        }
      }
      return this.distanceFieldShow.column
    },
    kmServiceFields() {
      if (this.distanceFieldShow) {
        return this.kmStoredFields
      } else {
        return this.kmInitialFields
      }
    },
    kmInitialFields() {
      return [
        {
          key: 'service.name',
          label: 'maintenance.field.compName',
          isSortable: true,
          isRedirectable: true,
          formatter: (val, key, item) => {
            return `${val} (${item.service.serviceAction.action})`
          },
          thStyle: 'width: 250px',
          tdAttr: {
            style: 'left:50px;position:sticky!important;min-width:250px;max-width:250px;',
          },
          thAttr: {
            style: 'left:50px;position:sticky!important;min-width:250px;max-width:250px;z-index:1;',
          },
          isLocked: true,
          isSticky: true,
        },
        {
          key: 'status',
          label: 'maintenance.field.statusService',
          isSortable: true,
          tdAttr: {
            style: 'left:299.5px;position:sticky;',
          },
          thAttr: {
            style: 'left:299.2px;position:sticky;z-index:1;',
          },
          formatter: (val) => {
            let format = { color: 'green', label: this.$t('maintenance.status.normal') }
            if (val.includes('I')) {
              format = { color: 'blue', label: this.$t('maintenance.status.inService') }
            } else if (val.includes('LO') || val.includes('LD')) {
              format = { color: 'red', label: this.$t('maintenance.status.lateService') }
            } else if (val.includes('SO') || val.includes('SD')) {
              format = {
                color: 'yellow',
                label: this.$t('maintenance.status.approachingService'),
              }
            }
            return format
          },
          isLocked: true,
          isSticky: true,
        },
        ...this.optionalFields,
        {
          key: 'method',
          label: 'maintenance.methodScheduler',
          shown: false,
        },
        {
          key: 'intervalDistance',
          label: 'maintenance.form.intKm',
          isSortable: false,
          formatter: (val) => {
            return `${this.thousandFormat(val)} km`
          },
        },
        {
          key: 'startServiceAtDistance',
          label: 'maintenance.form.odoNextService',
          isSortable: false,
          formatter: (val) => {
            return `${this.thousandFormat(val)} km`
          },
        },
        {
          key: 'serviceDistanceDifference',
          label: 'maintenance.form.kilometerDifference',
          isSortable: true,
        },
        {
          key: 'intervalTime',
          label: 'maintenance.form.intTime',
          isSortable: true,
          formatter: (value, key, item) => {
            let period = this.$t('global.time.days')
            switch (item.intervalPeriod) {
              case 'w':
                period = this.$t('global.time.week')
                break
              case 'm':
                period = this.$t('global.time.month')
                break
              case 'y':
                period = this.$t('global.time.year')
                break

              default:
                break
            }
            return `${value} ${period}`
          },
        },
        {
          key: 'startServiceAtTime',
          label: 'maintenance.form.dateNextService',
          isSortable: true,
          formatter: (val) => {
            return this.momentDateShortMonth(val)
          },
        },
        {
          key: 'serviceTimeDifference.readableText',
          label: 'maintenance.form.timeDifference',
          isSortable: true,
        },
      ]
    },
    kmFields() {
      const fields = cloneDeep(this.kmServiceFields)
      fields.forEach((item) => (item.label = `${this.$t(item.label)}`))
      return fields
    },

    storedRefrigeratorFields() {
      for (const field of this.refrigeratorFieldShow.column) {
        if (field.key == 'service.name') {
          field.formatter = (val, key, item) => {
            return `${val} (${item.service.serviceAction.action})`
          }
        }
        if (field.key == 'status') {
          field.formatter = (val) => {
            let format = { color: 'green', label: this.$t('maintenance.status.normal') }
            if (val.includes('I')) {
              format = { color: 'blue', label: this.$t('maintenance.status.inService') }
            } else if (val.includes('LH')) {
              format = { color: 'red', label: this.$t('maintenance.status.lateService') }
            } else if (val.includes('SH')) {
              format = {
                color: 'yellow',
                label: this.$t('maintenance.status.approachingService'),
              }
            }
            return format
          }
        }
        if (
          field.key == 'intervalRefrigerator' ||
          field.key == 'startServiceAtRefrigerator' ||
          field.key == 'serviceRefrigeratorDifference'
        ) {
          field.formatter = (val) => {
            return `${this.minuteToHour(val ?? 0)}`
          }
        }
      }
      return this.refrigeratorFieldShow.column
    },
    refrigeratorServiceFields() {
      if (this.refrigeratorFieldShow) {
        return this.storedRefrigeratorFields
      } else {
        return this.refrigeratorInitialFields
      }
    },
    refrigeratorInitialFields() {
      return [
        {
          key: 'service.name',
          label: 'maintenance.field.compName',
          isSortable: true,
          isRedirectable: true,
          formatter: (val, key, item) => {
            return `${val} (${item.service.serviceAction.action})`
          },
          thStyle: 'width: 250px',
          tdAttr: {
            style: 'left:50px;position:sticky!important;min-width:250px;max-width:250px;',
          },
          thAttr: {
            style: 'left:50px;position:sticky!important;min-width:250px;max-width:250px;z-index:1;',
          },
          isLocked: true,
          isSticky: true,
        },
        {
          key: 'status',
          label: 'maintenance.field.statusService',
          isSortable: true,
          tdAttr: {
            style: 'left:299.5px;position:sticky;',
          },
          thAttr: {
            style: 'left:299.2px;position:sticky;z-index:1;',
          },
          formatter: (val) => {
            let format = { color: 'green', label: this.$t('maintenance.status.normal') }
            if (val.includes('I')) {
              format = { color: 'blue', label: this.$t('maintenance.status.inService') }
            } else if (val.includes('LH')) {
              format = { color: 'red', label: this.$t('maintenance.status.lateService') }
            } else if (val.includes('SH')) {
              format = {
                color: 'yellow',
                label: this.$t('maintenance.status.approachingService'),
              }
            }
            return format
          },
          isLocked: true,
          isSticky: true,
        },
        ...this.optionalFields,
        {
          key: 'method',
          label: 'maintenance.methodScheduler',
          shown: false,
        },
        {
          key: 'intervalRefrigerator',
          label: 'maintenance.form.refrigeratorInterval',
          isSortable: false,
          formatter: (val) => {
            return `${this.minuteToHour(val ?? 0)}`
          },
        },
        {
          key: 'startServiceAtRefrigerator',
          label: 'maintenance.field.nextRefrigeratorService',
          isSortable: false,
          formatter: (val) => {
            return `${this.minuteToHour(val ?? 0)}`
          },
        },
        {
          key: 'serviceRefrigeratorDifference',
          label: 'maintenance.field.serviceRefrigeratorDifference',
          isSortable: false,
          formatter: (val) => {
            return `${this.minuteToHour(val ?? 0)}`
          },
        },
      ]
    },
    refrigeratorFields() {
      const fields = cloneDeep(this.refrigeratorServiceFields)
      fields.forEach((item) => (item.label = `${this.$t(item.label)}`))
      return fields
    },

    storedHourmeterFields() {
      for (const field of this.hourmeterFieldShow.column) {
        if (field.key == 'service.name') {
          field.formatter = (val, key, item) => {
            return `${val} (${item.service.serviceAction.action})`
          }
        }
        if (field.key == 'status') {
          field.formatter = (val) => {
            let format = { color: 'green', label: this.$t('maintenance.status.normal') }
            if (val.includes('I')) {
              format = { color: 'blue', label: this.$t('maintenance.status.inService') }
            } else if (val.includes('LH')) {
              format = { color: 'red', label: this.$t('maintenance.status.lateService') }
            } else if (val.includes('SH')) {
              format = {
                color: 'yellow',
                label: this.$t('maintenance.status.approachingService'),
              }
            }
            return format
          }
        }
        if (
          field.key == 'intervalHourmeter' ||
          field.key == 'startServiceAtHourmeter' ||
          field.key == 'serviceHourmeterDifference'
        ) {
          field.formatter = (val) => {
            return `${this.minuteToHour(val ?? 0)}`
          }
        }
      }
      return this.hourmeterFieldShow.column
    },
    hourmeterServiceFields() {
      if (this.hourmeterFieldShow) {
        return this.storedHourmeterFields
      } else {
        return this.hourmeterInitialFields
      }
    },
    hourmeterInitialFields() {
      return [
        {
          key: 'service.name',
          label: 'maintenance.field.compName',
          isSortable: true,
          isRedirectable: true,
          formatter: (val, key, item) => {
            return `${val} (${item.service.serviceAction.action})`
          },
          thStyle: 'width: 250px',
          tdAttr: {
            style: 'left:50px;position:sticky!important;min-width:250px;max-width:250px;',
          },
          thAttr: {
            style: 'left:50px;position:sticky!important;min-width:250px;max-width:250px;z-index:1;',
          },
          isLocked: true,
          isSticky: true,
        },
        {
          key: 'status',
          label: 'maintenance.field.statusService',
          isSortable: true,
          tdAttr: {
            style: 'left:299.5px;position:sticky;',
          },
          thAttr: {
            style: 'left:299.2px;position:sticky;z-index:1;',
          },
          formatter: (val) => {
            let format = { color: 'green', label: this.$t('maintenance.status.normal') }
            if (val.includes('I')) {
              format = { color: 'blue', label: this.$t('maintenance.status.inService') }
            } else if (val.includes('LH')) {
              format = { color: 'red', label: this.$t('maintenance.status.lateService') }
            } else if (val.includes('SH')) {
              format = {
                color: 'yellow',
                label: this.$t('maintenance.status.approachingService'),
              }
            }
            return format
          },
          isLocked: true,
          isSticky: true,
        },
        ...this.optionalFields,
        {
          key: 'method',
          label: 'maintenance.methodScheduler',
          shown: false,
        },
        {
          key: 'intervalHourmeter',
          label: 'maintenance.form.hourmeterInterval',
          isSortable: false,
          formatter: (val) => {
            return `${this.minuteToHour(val ?? 0)}`
          },
        },
        {
          key: 'startServiceAtHourmeter',
          label: 'maintenance.field.nextHourmeterService',
          isSortable: false,
          formatter: (val) => {
            return `${this.minuteToHour(val ?? 0)}`
          },
        },
        {
          key: 'serviceHourmeterDifference',
          label: 'maintenance.field.serviceHourmeterDifference',
          isSortable: false,
          formatter: (val) => {
            return `${this.minuteToHour(val ?? 0)}`
          },
        },
      ]
    },
    hourmeterFields() {
      const fields = cloneDeep(this.hourmeterServiceFields)
      fields.forEach((item) => (item.label = `${this.$t(item.label)}`))
      return fields
    },

    serviceOrderSubs() {
      return this.hasAccess([
        'service_order:read',
        'service_order:update',
        'service_order:create',
        'service_order:delete',
      ])
    },
  },

  created() {
    this.setDefaultFields()
  },

  methods: {
    setDefaultFields() {
      this.checkNewField()

      const defaultKilometer = this.kmInitialFields.map((field) => {
        if (!field.hasOwnProperty('shown')) field.shown = true
        return field
      })
      if (!localStorage.getItem('ssDistanceFields')) {
        this.distanceFieldShow = { column: defaultKilometer }
        localStorage.setItem('ssDistanceFields', JSON.stringify(this.distanceFieldShow))
      }

      const defaultHourmeter = this.hourmeterInitialFields.map((field) => {
        if (!field.hasOwnProperty('shown')) field.shown = true
        return field
      })
      if (!localStorage.getItem('ssHourmeterFields')) {
        this.hourmeterFieldShow = { column: defaultHourmeter }
        localStorage.setItem('ssHourmeterFields', JSON.stringify(this.hourmeterFieldShow))
      }

      const defaultRefrigerator = this.refrigeratorInitialFields.map((field) => {
        if (!field.hasOwnProperty('shown')) field.shown = true
        return field
      })
      if (!localStorage.getItem('ssRefrigeratorFields')) {
        this.refrigeratorFieldShow = { column: defaultRefrigerator }
        localStorage.setItem('ssRefrigeratorFields', JSON.stringify(this.refrigeratorFieldShow))
      }
    },

    checkNewField() {
      const distanceFields = this.distanceFieldShow?.column
      const hourmeterFields = this.hourmeterFieldShow?.column
      const refrigeratorFields = this.refrigeratorFieldShow?.column

      if (this.serviceOrderSubs) {
        this.kmInitialFields.forEach((field) => {
          if (!distanceFields?.find((item) => item.key == field.key)) {
            localStorage.removeItem('ssDistanceFields')
            this.distanceFieldShow = {}
          }
        })
        this.hourmeterInitialFields.forEach((field) => {
          if (!hourmeterFields?.find((item) => item.key == field.key)) {
            localStorage.removeItem('ssHourmeterFields')
            this.hourmeterFieldShow = {}
          }
        })
        this.refrigeratorInitialFields.forEach((field) => {
          if (!refrigeratorFields?.find((item) => item.key == field.key)) {
            localStorage.removeItem('ssRefrigeratorFields')
            this.refrigeratorFieldShow = {}
          }
        })
      } else {
        distanceFields?.forEach((field) => {
          if (!this.kmInitialFields?.find((item) => item.key == field.key)) {
            localStorage.removeItem('ssDistanceFields')
            this.distanceFieldShow = {}
          }
        })
        hourmeterFields?.forEach((field) => {
          if (!this.hourmeterInitialFields?.find((item) => item.key == field.key)) {
            localStorage.removeItem('ssHourmeterFields')
            this.hourmeterFieldShow = {}
          }
        })
        refrigeratorFields?.forEach((field) => {
          if (!this.refrigeratorInitialFields?.find((item) => item.key == field.key)) {
            localStorage.removeItem('ssRefrigeratorFields')
            this.refrigeratorFieldShow = {}
          }
        })
      }
    },

    openModal() {
      this.modal = true
      setTimeout(() => {
        this.$bvModal.show('modal-unlink-group')
      }, 500)
    },

    updateTotal(type, value) {
      this.total[type] = value

      const selectedOption = this.tabOptions.find((item) => item.value == this.tabSelected)
      if (!selectedOption) {
        this.tabSelected = this.tabOptions[0]?.value ?? '1'
      }
    },

    async get(filter) {
      if (this.created) filter.orderBy = [JSON.stringify({ status: 'asc' })]
      this.created = false

      this.filter = filter
      const res = await this.$apollo.query({
        query: GET_SERVICE_SCHEDULES,
        fetchPolicy: 'no-cache',
        variables: {
          filter: {
            ...filter,
            vehicleId: Number(this.$route.params.vehicleId),
            vehicleStatus: ['I', 'R'],
          },
        },
      })

      if (res.data.serviceSchedules.isSuccessful) {
        const scheduleData = res.data.serviceSchedules.serviceSchedules.data
        const headerKeyByType = {
          DistanceAndTime: 'distanceAndTime',
          Hourmeter: 'hourmeter',
          Refrigerator: 'refrigerator',
        }
        const headerKey = headerKeyByType[filter.type]

        this.dataheader[headerKey] = {
          totalLate: scheduleData.totalLate,
          totalSoon: scheduleData.totalSoon,
          totalInProgress: scheduleData.totalInProgress,
          totalNormal: scheduleData.totalNormal,
        }

        const { serviceSchedules } = scheduleData

        serviceSchedules.forEach((row) => {
          if (row.ssgroup) {
            const ssgroupData = row.ssgroup?.service2Ssgroup?.find(
              (item) => item.serviceId == row.serviceId
            )
            if (ssgroupData) {
              row.intervalDistance = ssgroupData.intervalDistance
              row.reminderDistance = ssgroupData.reminderDistance
              row.intervalTime = ssgroupData.intervalTime
              row.intervalPeriod = ssgroupData.intervalPeriod
              row.intervalHourmeter = ssgroupData.intervalHourmeter
              row.intervalRefrigerator = ssgroupData.intervalRefrigerator
              row.reminderTime = ssgroupData.reminderTime
              row.reminderPeriod = ssgroupData.reminderPeriod
              row.reminderHourmeter = ssgroupData.reminderHourmeter
              row.reminderRefrigerator = ssgroupData.reminderRefrigerator
            }
          }
        })

        const result = {
          data: serviceSchedules,
          pagination: res.data.serviceSchedules.serviceSchedules.pagination,
        }
        // set total, if total <= 0, tab will not be shown
        this.updateTotal(filter.type, result.pagination.total)

        return result
      }

      return null
    },

    checkSsgroup(value) {
      let count = 0
      value.map((item) => {
        if (item.ssgroup !== null) {
          count += 1
        }
      })

      if (count != 0) this.isDisabled = false
      else this.isDisabled = true
    },

    async refreshData() {
      this.render = false
      this.modal = false
      this.isLoading = true
      this.$apollo.queries.serviceSchedules.refetch({ fetchPolicy: 'no-cache' })
      await this.get(this.filter)
      setTimeout(() => {
        this.render = true
        this.modal = true
        this.isLoading = false
      }, 500)
    },

    async refreshVehicle() {
      this.refresh = true

      const res = await this.$apollo.queries.vehicle.refetch({
        filter: {
          id: Number(this.$route.params.vehicleId),
        },
      })

      this.vehicle = res.data.vehicle.vehicle

      await this.getOdometerUpdate()

      return res
    },
    async getOdometerUpdate() {
      const res = await this.$apollo.queries.vehicleStatus.refetch({
        filter: {
          vehicleId: Number(this.$route.params.vehicleId),
        },
      })

      this.vehicleStatus = res.data.vehicleStatus.vehicleStatus
      return res
    },
    handleFieldDistance(fields) {
      localStorage.setItem('ssDistanceFields', JSON.stringify({ column: fields }))
    },
    handleFieldHourmeter(fields) {
      localStorage.setItem('ssHourmeterFields', JSON.stringify({ column: fields }))
    },
    handleFieldRefrigerator(fields) {
      localStorage.setItem('ssRefrigeratorFields', JSON.stringify({ column: fields }))
    },
    customToast() {
      this.$mcToast.error({
        component: 'McToastDynamicBody',
        props: {
          contents: [
            {
              tag: 'h6',
              text: this.$t('maintenance.alert.deleteFailed'),
            },
            {
              tag: 'p',
              text: this.$t('maintenance.alert.failedDeteleUsed'),
            },
          ],
        },
      })
    },
    handleSelected(value) {
      this.selectedDataLength = value
    },
    handleSelectedValue(ids) {
      const keys = Object.keys(ids)
      const selectedIds = keys.filter((key) => Number(ids[key]))

      this.selectedIds = selectedIds.map((item) => Number(item))
      this.selectedItems = this.dataServices.filter((item) =>
        this.selectedIds.includes(item.serviceId)
      )
    },
  },
}
</script>
